export interface ISCOLARITE {
  mois?: string;
  ecoleId?: string;
  dateDebut?: string;
  annee?: string;
  id?: string;
  moisAnnee?: string;
  statutScolarite?: string;
  page?: number;
  size?: number;
  anneeScolaireId?: string;
}

export const defaultValue: Readonly<ISCOLARITE> = {
  mois: '',
  ecoleId: '',
  dateDebut: '',
  annee: '',
  id: null,
  moisAnnee: '',
  statutScolarite: '',
  page: 0,
  size: 0,
  anneeScolaireId: '',
};

export enum StatutScolarite {
  EMIS = 'EMIS',
  EN_ATTENTE = 'EN_ATTENTE',
}
